import { render, staticRenderFns } from "./signInPage.html?vue&type=template&id=2a4280bd&"
import script from "./signInPage.vue?vue&type=script&lang=js&"
export * from "./signInPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports